<!--Gallery-->
<div class="screenshot-files-content">
  @if (app?.screenshotUrls?.length > 0) {
    <mat-card appearance="outlined">
      <h2 class="title">Gallery</h2>
      <mat-card-content>
        <section class="app-section-padding">
          <span>
            <section class="screenshot-container">
              @for (img of app?.screenshotUrls; track img; let i = $index) {
                <div class="screenshot-item" (click)="onClick(i)">
                  <img class="screenshot-img" [src]="img" [srcset]="getSrcsetImageUrls(img)" />
                </div>
              }
            </section>
          </span>
        </section>
      </mat-card-content>
    </mat-card>
  }

  <!--Files-->
  @if (app && app?.files?.length > 0) {
    <mat-card appearance="outlined">
      <h2 class="title">Files & Documents</h2>
      <mat-card-content>
        <section>
          <span>
            <div class="content-container">
              @for (file of app?.files; track file) {
                <div class="item-container-6">
                  <a href="{{ file.url }}" target="_blank">
                    <div class="card-container">
                      <mat-card appearance="outlined" class="mat-card-no-shadow">
                        <mat-card-content class="file-content">
                          <mat-icon class="file-icon file-large-icon" role="img" aria-hidden="true">
                            insert_drive_file
                          </mat-icon>
                          {{ getFileName(file) }}
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </a>
                </div>
              }
            </div>
          </span>
        </section>
      </mat-card-content>
    </mat-card>
  }
</div>
